import { useState } from 'react'
import { Alert, Button, Card, Form, Input, Typography } from 'antd'
import { login, Staff } from './api'

const { Text, Title } = Typography
const DEFAULT_STORE_ID = '018f0000-0000-7000-8000-000000000001'

export default function LoginPage({ onLogin }: { onLogin: (staff: Staff) => void }) {
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const submit = async (values: { username: string; password: string }) => {
    setSubmitting(true)
    setError('')
    try {
      onLogin(await login({ storeId: DEFAULT_STORE_ID, ...values }))
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : '登录失败，请稍后重试')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="login-page">
      <Card className="login-card">
        <div className="login-brand"><span className="brand-mark">炒</span></div>
        <Title level={2}>家常小炒管理后台</Title>
        <Text type="secondary">使用门店员工账号登录</Text>
        {error && <Alert type="error" message={error} showIcon />}
        <Form layout="vertical" onFinish={(values) => void submit(values)} requiredMark={false}>
          <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input size="large" autoComplete="username" maxLength={64} />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password size="large" autoComplete="current-password" maxLength={256} />
          </Form.Item>
          <Button type="primary" htmlType="submit" size="large" block loading={submitting}>登录</Button>
        </Form>
      </Card>
    </main>
  )
}
